import React from 'react';
import { InputNumber, Text, InputSizes, TextAs, TextSizes } from '@clockout-dev/design-elements';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import styles from '../styles/limitsForm.module.scss';

function MinMaxVolumeCard({ min, max, enabled, onChangeMin, onChangeMax, onToggleEnabled }) {
    return (
        <ConfigurationCard
            title="Min & Max Volume per Advance"
            description="Lowest & highest amount a user can withdraw per advance"
            togglePosition="leading"
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <div className={styles.cardInputRow}>
                <InputNumber
                    size={InputSizes.SMALL}
                    value={min}
                    prefix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>}
                    suffix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>min</Text>}
                    onChange={onChangeMin}
                    min={0}
                    max={99999.99}
                    step={0.01}
                    precision={2}
                    controls={false}
                    className={`${styles.inlineNumberInput} ${styles.amountField}`}
                />
                <Text as="span" size="s" className={styles.ruleLabel}>to</Text>
                <InputNumber
                    size={InputSizes.SMALL}
                    value={max}
                    prefix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>}
                    suffix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>max</Text>}
                    onChange={onChangeMax}
                    min={0}
                    max={99999.99}
                    step={0.01}
                    precision={2}
                    controls={false}
                    className={`${styles.inlineNumberInput} ${styles.amountField}`}
                />
                <Text as="span" size="s" className={styles.ruleLabel}>per Advance</Text>
            </div>
        </ConfigurationCard>
    );
}

export default MinMaxVolumeCard;
